module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Chat__wrapper"
  }, [_c('div', {
    staticClass: "Chat__main-container"
  }, [_c('transition', {
    attrs: {
      "name": "appear-from-top"
    }
  }, [(!_vm.messages.length) ? _c('div', {
    staticClass: "Chat__empty-result-box"
  }, [_c('div', {
    staticClass: "Chat__empty-result-img"
  }), _vm._v(" "), _c('div', {
    staticClass: "Chat__empty-result-text"
  }, [_vm._v("\n        No messages yet.\n        "), _c('br'), _vm._v("\n        Start chatting!\n      ")])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "appear-from-bottom"
    }
  }, [(_vm.messages.length) ? _c('div', {
    staticClass: "Chat__container"
  }, [_vm._l((_vm.messages), function(msg, index) {
    return _c('div', {
      key: index,
      staticClass: "Chat__message"
    }, [_c('div', {
      staticClass: "Chat__message-info"
    }, [_c('img', {
      staticClass: "Chat__message-author-avatar",
      attrs: {
        "src": _vm.getUserInfo(msg.creatorId).avatarUrl || '../../../../static/images/default-user-avatar.jpg'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "Chat__message-author-name"
    }, [_vm._v("\n            " + _vm._s(_vm.getUserInfo(msg.creatorId).name) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "Chat__message-sent-at"
    }, [_vm._v("\n            " + _vm._s(_vm._f("moment")(msg.createdAtMillis, "h:mm a")) + "\n          ")])]), _vm._v(" "), (msg.bodyType.text) ? _c('div', {
      staticClass: "Chat__message-text-container"
    }, [_vm._v("\n          " + _vm._s(msg.bodyType.text.body) + "\n        ")]) : (msg.bodyType.ping) ? _c('div', {
      staticClass: "Chat__message-ping-container"
    }, [_c('i', {
      staticClass: "icon-ic_hand-up"
    })]) : (msg.bodyType.image) ? _c('div', {
      staticClass: "Chat__message-image-container"
    }, [_c('img', {
      directives: [{
        name: "fallback-src",
        rawName: "v-fallback-src",
        value: ('../../../../static/images/default-user-avatar.jpg'),
        expression: "'../../../../static/images/default-user-avatar.jpg'"
      }],
      staticClass: "Chat__message-image",
      attrs: {
        "src": msg.bodyType.image.imageUrl
      }
    })]) : _vm._e()])
  }), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoading",
    staticClass: "Chat__infinite-loading-container",
    attrs: {
      "spinner": "circles",
      "direction": "top",
      "on-infinite": _vm.getMessages
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })])], 2) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "Chat__footer"
  }, [_c('transition', {
    attrs: {
      "name": "appear-from-bottom",
      "mode": "out-in"
    }
  }, [(_vm.percentComplete) ? _c('progress-circle', {
    staticClass: "Chat__attach-progress",
    attrs: {
      "progress": _vm.percentComplete
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('input', {
    staticClass: "Chat__attach-input",
    attrs: {
      "id": "file-upload",
      "type": "file",
      "accept": "image/*",
      "name": "fileUpload"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "Chat__message-field",
    attrs: {
      "type": "text",
      "name": "message",
      "placeholder": "Type your message here..."
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-ic_hand-up Chat__hand-up",
    on: {
      "click": _vm.handUp
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c370115","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/room/chat/chat.vue
// module id = 422
// module chunks = 1